import TinyMCE from "components/TinyMCE";
import { useSelector, useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getRxAppData, setRxAppData } from '../redux/appCenterSlice';
import { initializeAuth, saveAppDetails } from "services/apiService";

export default function Tutorials() {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const app = useSelector(getRxAppData);

  const saveChange = async(text: string) => {
    const appData = { ...app, tutorials: text };
    await initializeAuth(instance, accounts);
    saveAppDetails(appData);
    dispatch(setRxAppData(appData));
  }

  return (
    <TinyMCE editorText={app.tutorials} header={'Tutorials'} onSave={saveChange}></TinyMCE>
  ) 
}

